import { glob } from '../../glob';
import { EventBus } from '../EventBus';

const KEY = Symbol.for('globalEventBus');

export const globalEventBus = glob[KEY] = glob[KEY] || new EventBus();
